import { UserApi } from '../../../common/constants/user-api';
import { getResponseData } from '../../../common/utils/api-utils';
import { abortWrapper } from '../../../common/utils/util';
import { getAppFlow } from '../utils/user-profile.util';

export const getUserSchools = abortWrapper(async (body, signal) => {
  const url = new URL(UserApi.getSchools);
  return await getResponseData(
    new Request(url.toString(), {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Flow': getAppFlow()
      },
      body: JSON.stringify(body),
      signal
    })
  );
});
